
import { Placement } from '@post-office/placements-frontend/bac-subscription-details-banner';
export default Placement;
